<template>
  <div class="public-studioAdmin-body">
    <StudioAdminTabs :list="tabs" :newIndex="view" @change="tabsChange"></StudioAdminTabs>
    <div class="contentBox">
      <!-- 筛选 -->
      <div class="selectTop">
        <div class="lBox public-form-studioAdmin">
          <div>
            <el-input v-model="form.search_name" placeholder="请输入文章标题" class="input" style="margin-left: 0"></el-input>

            <el-input v-model="form.search_realname" placeholder="发布人姓名" class="input width110"></el-input>

            <el-select v-model="form.type" placeholder="文章分类" class="sid" style="width: 200px; margin-left: 10px">
              <template v-for="item in typeList">
                <el-option v-if="item.title_status == '显示'" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="selectType(item.id)">
                </el-option>
              </template>
            </el-select>

            <el-select v-model="form.show_type" placeholder="展示状态" class="sid" style="width: 120px; margin-left: 10px"
              v-if="view == 0">
              <el-option v-for="item in optiones_display" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

            <el-select v-model="form.status" placeholder="审核状态" class="sid" style="width: 120px; margin-left: 10px"
              v-if="view == 1">
              <el-option v-for="item in optiones" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

            <el-button class="ml10" type="primary" @click="search()">查询</el-button>
            <el-button @click="reset()">重置</el-button>
          </div>
          <div class="mt10 df dfb" v-if="view == 0">
            <div>
              <el-button type="primary" @click="recommendBatch()" :disabled="ids.length == 0">批量推荐</el-button>
              <el-button class="btn-blue" @click="delBatch()" :disabled="ids.length == 0">批量删除</el-button>
              <el-button class="btn" @click="add()">新增文章</el-button>
            </div>
            <div>
              <el-button class="btn-green" @click="classify()">文章分类管理</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="tableList">
        <el-table :data="tableData" :stripe="true" @selection-change="tableSelectionChange"
          class="public-table-studioAdmin">
          <el-table-column type="selection" width="45">
          </el-table-column>
          <el-table-column type="index" label="序号" align="center" width="70">
          </el-table-column>
          <el-table-column label="文章标题" head-align="center">
            <template slot-scope="scope">
              <div class="studioAdmin-info-text">
                <p class="info-title">{{ scope.row.name }}</p>
                <span class="info-labelTop" v-if="scope.row.status == 3">{{ scope.row.status == 3 ? "推荐" : "" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="文章分类" prop="type_name" align="center" width="100"></el-table-column>
          <el-table-column label="浏览" prop="view_count" align="center" width="70"></el-table-column>
          <el-table-column label="发布人" prop="username" align="center" width="90"></el-table-column>
          <el-table-column label="发布时间" prop="start_date" align="center" width="180"></el-table-column>
          <el-table-column label="展示状态" align="center" width="100" v-if="view == 0">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_show" active-color="#3489FF" :active-value="1" :inactive-value="0"
                @change="isShowChange(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" align="center" width="100" v-if="view == 1">
            <template slot-scope="scope">
              <p class="text-color-orange" v-if="scope.row.status == 1">待审核</p>
              <p class="text-color-red" v-if="scope.row.status == 4">未通过</p>
              <p class="text-color-grey" v-if="scope.row.status == 2 || scope.row.status == 3">已通过</p>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作" align="center" width="230">
            <template slot-scope="scope">
              <el-button type="text" class="text-color-blue" @click="detail(scope.row.id)">详情</el-button>
              <template v-if="view == 0">
                <el-button type="text" class="text-color-blue" @click="edit(scope.row.id)">编辑</el-button>
                <el-button type="text" @click="del([scope.row.id])" class="text-color-red">删除</el-button>
                <el-button type="text" class="text-color-blue" @click="top(scope.row)">{{ scope.row.status == 2 ? "推荐" : "取消推荐" }}</el-button>
              </template>
              <template v-if="view == 1 && scope.row.status == 1">
                <el-button type="text" @click="examineButton(scope.row, 2)" class="text-color-blue">通过</el-button>
                <el-button type="text" @click="examineButton(scope.row, 4)" class="text-color-red">不通过</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box" v-show="total">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="form.page" :page-size="form.limit" layout="prev, pager, next,jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      optiones_display: [
        {
          id: 1,
          name: "展示",
        },
        {
          id: 2,
          name: "隐藏",
        },
        {
          id: 3,
          name: "推荐",
        },
      ],
      optiones: [
        {
          id: 1,
          name: "待审核",
        },
        {
          id: 2,
          name: "已通过",
        },
        {
          id: 4,
          name: "未通过",
        },
      ],
      //表格数据
      tableData: [],
      //总数
      total: 0,
      //表单数据
      form: {
        page: 1,
        limit: 10,
        status: "",
        type: "",
        search_name: "",
        search_realname: "",
        teaching_studio_id: localStorage.getItem("studioId"),
        order_type: 1,
        show_type: ""
      },
      typeList: [],
      //导航
      tabs: [
        {
          label: "教师文章管理",
          count: 0
        },
        {
          label: "教师文章审核",
          count: 0
        }
      ],
      //页面索引
      view: 0,
      //审核表单数据
      examineForm: {
        id: 0,
        teaching_studio_id: localStorage.getItem("studioId"),
        status: 0,
        reason: ''
      },
      //表格选择id
      ids: []
    };
  },
  created() {
    let rouName = this.$route.name
    this.$emit('rouname', rouName)
    //判断是否审核页
    if (this.$route.query.hasOwnProperty('type') && this.$route.query.type == 2) {
      this.view = 1;
      this.form.order_type = 2;
    }
    this.init();
  },
  computed: {},
  methods: {
    //表格多选框选中数据
    tableSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
    },
    //批量推荐
    recommendBatch() {
      this.top(this.ids);
    },
    //批量删除
    delBatch() {
      this.del(this.ids);
    },
    //文章分类管理
    classify() {
      this.$router.push("/ArticleType");
    },
    //新增
    add() {
      this.$router.push("/AddArticleSet");
    },
    //详情
    detail(tid) {
      let routeData = this.$router.resolve({
        path: "/ArticleDetail",
        query: {
          tid
        },
      });
      window.open(routeData.href, '_blank');
    },
    //获取文章分类
    getArticleType() {
      let obj = {
        search_name: "",
        page: "",
        limit: "",
        teaching_studio_id: localStorage.getItem("studioId"),
      };
      this.$axios.get("TeachingStudioArticleType/list", { params: obj, }).then((res) => {
        this.typeList = res.data.data.data;
      });
    },
    //切换回调
    tabsChange(val) {
      this.view = val;
      this.form.page = 1;
      this.form.status = "";
      this.form.type = "";
      this.form.search_name = "";
      this.form.search_realname = "";
      this.form.order_type = val == 0 ? 1 : 2;
      this.form.show_type = "";
      this.tableData = []
      this.init();
    },
    //初始化
    init() {
      this.getArticleType();
      this.getList();
      this.examineCount();
    },
    //列表
    getList() {
      this.$axios
        .get("TeachingStudioArticleType/listTeachingStudioArtic", {
          params: this.form,
        })
        .then((res) => {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        });
    },
    //删除
    del(id) {
      this.myConfirm({
        content: `确定要删除当前数据吗？`,
        fn: this.delApi,
        id,
      });
    },
    //删除接口
    delApi(id) {
      let params = {
        ids: id,
        teaching_studio_id: localStorage.getItem('studioId')
      };
      this.$axios.delete("TeachingStudioArticle/del", {
        params
      }).then(() => {
        this.$message.success("删除成功");
        this.search()
      });
    },
    //搜索
    search() {
      this.form.page = 1;
      this.getList();
    },
    //重置
    reset() {
      this.form.page = 1;
      this.form.status = "";
      this.form.type = "";
      this.form.search_name = "";
      this.form.search_realname = "";
      this.form.show_type = "";
      this.getList();
    },
    //每页条数回调
    handleSizeChange(val) {
      this.form.limit = val;
      this.getList();
    },
    //当前页回调
    handleCurrentChange(val) {
      this.form.page = val;
      this.getList();
    },
    //编辑
    edit(id) {
      this.$router.push({
        path: "/AddArticleSet",
        query: {
          id
        }
      })
    },
    //是否显示回调
    isShowChange(e) {
      this.$axios
        .put("teachingStudioArticle/set_is_show", {
          id: e.id
        })
        .then(() => {
          this.getList();
        });
    },
    //推荐回调
    top(e) {
      let params = {
        teaching_studio_id: localStorage.getItem('studioId')
      }
      if (Array.isArray(e)) {
        params.ids = e;
        params.status = 3;
      } else {
        params.ids = [e.id];
        params.status = e.status == 2 ? 3 : 2;
      }
      this.$axios
        .put("teachingStudioArticle/recommend_status", params)
        .then(() => {
          this.getList();
        });
    },
    //审核按钮
    examineButton(e, val) {
      this.examineForm.id = e.id;
      this.examineForm.status = val;
      if (val == 2) {
        this.myConfirm({
          content: `是否确定通过审核？`,
          fn: this.examine
        });
      }
      if (val == 4) {
        this.$prompt('', '审核不通过', {
          customClass: 'examine-prompt',
          closeOnClickModal: false,
          showClose: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPattern: /^.+$/m,
          inputPlaceholder: '请输入拒绝理由',
          inputErrorMessage: '请输入拒绝理由'
        }).then((e) => {
          if (e.action == "confirm") {
            this.examineForm.reason = e.value;
            this.examine();
          }
        }).catch(() => {

        });
      }
    },
    //审核
    examine() {
      this.$axios
        .put("teachingStudioArticle/status", this.examineForm)
        .then(() => {
          this.getList();
          this.examineCount();
          this.examineForm.reason = "";
        });
    },
    //审核不通过（提交）
    examinePopoverSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.examine();
        }
      });
    },
    //审核统计
    examineCount() {
      this.$axios
        .get("index/teachingStudioArticle/status_article", { params: { id: this.form.teaching_studio_id } })
        .then((res) => {
          this.tabs[1].count = res.data.data.status_article;
        });
    },
  },
};
</script>
<style lang="less" scoped></style>
